<template>
    <el-dialog :visible.sync="showDetail" id="typeshowhtml" append-to-body custom-class='xiangqing'  v-dialogDrag>
            <el-form>
             <div class="contrascont">
                <div class="lsde">
                    <div class="toppom">
                        <!-- <div v-if="currentDetailInfo.projectLampparamVo.makingWay == 2"> -->
                        <div v-html="embedHhtml">
                            <!-- <embed :src="this.ImgPath + currentDetailInfo.projectLampparamVo.pdfPath" width="100%" height="725px"> -->
                        </div>
                        
                    </div>    
                </div>
            </div>
            </el-form>
        </el-dialog>
</template>
<script>
import { Loading } from 'element-ui';
export default {
    data(){
        return{
            showDetail:false,
            embedHhtml:'',
            pdfSrc:'',
            rerecommend:false,//点击推荐灯参的话  为真  默认为false
        }
    },
    methods:{
        show(id){
            this.showDetail = true
            this.$http.get('/api/projectFeedback/viewLampparamPdf/'+id,{},(res)=>{
               if(res.success){
                   var pdfPath =res.data.fileName;
                    let pdfSrc = this.$http.getSignUrl('/api/previewPdf',{fileName:pdfPath,token:this.$store.state.token});
                    this.embedHhtml = `<embed src="${pdfSrc}" width="100%" height="725px">`

               }

            })
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" >
#typeshowhtml{
    background: rgba(0,0,0,.4);
    z-index: 99;
    .toppom{
        ul{
            max-height: 70vh;
         overflow: auto
        }
    }
    .el-dialog{
        width: 86%;
         margin-top: 5vh !important;
         
    }
    .el-dialog__body{
            padding-top: 0;
        }
    .contrascont{
        min-height: 120px;
        min-width: 260px;
        display: inline-block;
        vertical-align: middle;  
        font-size: 18px;
        text-align: left;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        padding: 0px !important;
        width: 100%;
        .hst{
            font-size:22px;
            font-weight: bold;
            color: #000;
            margin-bottom: 10px;
            text-align: center;
        }
        .lsde{
            img{
                max-height: 100%;
            }
            li{
                float: left;
                text-align: center;
                border: solid 1px rgba(184, 205, 217, 0.4);
                padding: 10px 12px;
                font-size: 14px;
                margin: 0;
            }
           .title{
               height: 48px;
                background-color: #5a63a3;
                text-align: center;
                line-height: 48px;
                color: #fff;
                font-size: 18px;
                width: 100%;
                padding: 0;
           }
           .cd1{
               background-color: #f6f7fb;
               text-align: center;
               height: 200px;
               width: 9%;
           }
           .cd2{
               width: 41%;
               height: 200px;
           }
           .cd3{
               width: 9%;
                background-color: #f6f7fb;
                height: 50px;
           }
           .cd4{
               width: 16%;
               height: 50px;
               text-align: left;
               padding: 0 12px;
           }
           .cd5{
               width: 50%;
               height: 50px;
               text-align: left;
                padding: 0 12px;
           }
           .cd6{
               width: 91%;
               padding: 15px 2%;
           }
           .cd7{
               height: 45px;
                background-color: #f6f7fb;
                width: 9%;
           }
           .cd8{
               height: 45px;
               width: 91%;
               text-align: left;
               padding: 0 15px;
           }
           .cd9{
               height: 45px;
               width: 41%;
               text-align: left;
               padding: 0 15px;
               .BoxTable{
                   height: 45px;
                   .BoxCell{
                       height: 45px;
                       div{
                           display: inline-block;
                           width: auto;
                       }
                   }
               }
           }
        }
        .lsdeList{
            text-align: right;
            margin-top: 20px;
            li{
                display: inline-block;
                margin-left: 16px;
                float: none;
                border: none;
                color: #666666;
                font-size: 14px;
                cursor: pointer;
                img{
                    display: inline-block;
                    position: relative;
                    top: 3px;
                    margin-right: 3px;
                }
            }
        }
        .close{
            position: absolute;
            right: 10px;
            top: 10px;
            background-color: #5a63a3;
            width: 28px;
            height: 28px;
            display: inline-block;
            color: #fff;
            border-radius: 50%;
            line-height: 28px;
            text-align: center
        }
    }
}
</style>